var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSei0)",
    d: "M17.833 15.6a6.82 6.82 0 0 0-.472-7.877c-.343.085-.561.278-.913.583q-.047.036-.094.085a2.87 2.87 0 0 1-2.006.823c-.458 0-.814-.086-1.123-.236c-.265-.137-.462-.317-.595-.437l-.03-.03c-.142-.128-.232-.201-.36-.257a1.7 1.7 0 0 0-.686-.111c-.489 0-.994.231-1.466.591a4.8 4.8 0 0 0-1.003 1.05l-1.071-.711a6 6 0 0 1 1.29-1.359a3.78 3.78 0 0 1 2.25-.857c.497 0 .887.077 1.213.223s.544.343.698.48c.163.15.24.214.343.27c.095.047.245.098.54.098c.515 0 .797-.197 1.157-.514l.112-.094q.356-.331.776-.579a6.87 6.87 0 0 0-11.229 4.436a3.3 3.3 0 0 1 1.239-.249a2.85 2.85 0 0 1 1.86.643l.017.013c.193.137.325.232.488.3c.15.064.343.116.643.116c.502 0 .827-.232 1.32-.613l.03-.026c.472-.368 1.11-.861 2.083-.861c.801 0 1.599.416 2.211.836a8.8 8.8 0 0 1 1.492 1.307l-.964.857a7.4 7.4 0 0 0-1.26-1.106c-.558-.381-1.08-.608-1.479-.608c-.506 0-.831.231-1.324.612l-.03.026c-.472.369-1.11.862-2.083.862c-.459 0-.827-.086-1.144-.219c-.3-.129-.536-.3-.72-.429l-.013-.008a2.6 2.6 0 0 0-.489-.3a1.6 1.6 0 0 0-.643-.116c-.493 0-.925.202-1.255.437a6.8 6.8 0 0 0 1.517 3.686c.227-.24.497-.493.793-.729c.565-.458 1.302-.921 2.078-1.028c.493-.073.909 0 1.273.154c.347.154.617.377.823.557l.047.043c.42.36.609.523.956.523c.398 0 .673-.184 1.071-.501l.077-.065c.365-.287.9-.72 1.646-.72c.33 0 .664.095.956.21c.3.116.6.279.883.446c.197.12.394.249.574.377zm-.78 1.028a6 6 0 0 0-.463-.3a4.4 4.4 0 0 0-.686-.351a1.4 1.4 0 0 0-.484-.12c-.27 0-.463.141-.913.501c-.407.326-.99.785-1.877.785c-.849 0-1.393-.48-1.749-.797l-.098-.086c-.193-.167-.343-.279-.498-.343a1 1 0 0 0-.574-.069c-.428.065-.943.352-1.453.759a9 9 0 0 0-.694.643a6.86 6.86 0 0 0 4.419 1.607a6.86 6.86 0 0 0 5.07-2.229"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSei0",
    x1: 11.983,
    x2: 11.983,
    y1: 5.143,
    y2: 18.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90305C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3C41"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSei);
export default __webpack_public_path__ + "static/media/sei.6f05edfeb5e731b06dc17f41f94319ec.svg";
export { ForwardRef as ReactComponent };